<template>
  <section
    class="component-ce7dba28"
    resmed-component-name="info_50/50_list_image"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
    }"
    v-bind:class="[`text-color-${acf.layout['text-color']}`]"
  >
    <div class="component">
      <div class="container">
        <div class="row align-items-center">
          <div
            class="col-md-6 col-xl-4 offset-xl-1"
            v-bind:class="{
              'order-md-2': acf.layout['image-placement'] === 'right',
            }"
          >
            <div
              class="wrapper d-flex align-items-center justify-content-center"
              v-bind:style="{
                'background-image': `url(${acf.layout['background-image']})`,
              }"
            >
              <div class="px-md-4 px-xl-0">
                <eyebrow-icon
                  v-if="acf.eyebrowicon"
                  v-bind:eyebrowicon="acf.eyebrowicon"
                  v-bind:align="'center'"
                ></eyebrow-icon>
                <h2 v-html="acf.headline"></h2>
              </div>
            </div>
          </div>
          <div
            class="col-md-6 col-xl-5 offset-xl-1"
            v-bind:class="{
              'justify-content-center':
                acf.layout['image-placement'] === 'right',
            }"
          >
            <div class="wrapper">
              <div
                class="mb-4"
                v-if="acf.introduction"
                v-html="acf.introduction"
              ></div>
              <ul>
                <li v-for="(content, index) in acf.content">
                  <div class="numbers" v-if="acf.layout['list-style'] === 'ol'">
                    <span>{{ index + 1 }}</span>
                  </div>
                  <div class="bullets" v-if="acf.layout['list-style'] === 'ul'">
                    <span>•</span>
                  </div>
                  <span v-html="content.item"></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ce7dba28", // info_50/50_list_image
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ce7dba28 {
  padding: 2rem 0;

  &.text-color-white {
    h2,
    li {
      color: $cc-resmed-white;
    }

    h2 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }

    ul {
      li:not(:last-child) {
        border-bottom: 1px solid rgba($cc-resmed-white, 0.25);
      }

      li {
        > .numbers span {
          border: 1px solid $cc-resmed-white;
        }
      }
    }
  }

  &.text-color-black {
    ul {
      li:not(:last-child) {
        border-bottom: 1px solid rgba($cc-resmed-dark-grey, 0.25);
      }

      li {
        > .numbers span {
          border: 1px solid rgba($cc-resmed-dark-grey, 0.325);
        }
      }
    }
  }
}

.component {
  h2 {
    position: relative;
    margin: 0;
    text-align: center;

    @extend %eyebrow-center;
  }

  .wrapper {
    padding: 3rem 0;
    min-height: 220px;

    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;

    @media (min-width: 992px) {
      padding: 5rem 0;
      min-height: 290px;
    }
  }

  ul {
    list-style: none;

    li:not(:last-child) {
      margin-bottom: 1.25rem;
      padding-bottom: 1.25rem;
    }

    li {
      > span {
        display: block;
        padding-left: 2.5rem;
      }

      .bullets {
        span {
          transform: scale(1.75);
        }
      }

      .numbers {
        span {
          // -->
        }
      }

      .bullets,
      .numbers {
        overflow: hidden;
        float: left;
        transform: translate3d(0, 0, 0);

        span {
          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 50%;
          width: 1.75rem;
          height: 1.75rem;

          text-align: center;

          @extend %body-small;
        }
      }
    }
  }
}
</style>